module.exports = {
  languages: [`hu`, `en`, `de`],
  defaultLanguage: `en`,
}
